import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

const schema = yup.object({
    status_ID: yup.number().required("Status is required").min(1, "Status is required"),
    source_ID: yup.number().required("Source is required").min(1, "Source is required"),
    assigned_To: yup.number().nullable(),
});

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [contacts, setContacts] = useState<IDropdown[]>();
    const [sources, setSources] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();
    const [users, setUsers] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });
    const contact = watch("contact");

    const sourceID = contacts?.find((item) => item?.id === contact?.id)?.source_ID || 0;
    // setValue("source_ID", sourceID);


    setValue("status_ID", 5)

    useEffect(() => {
        loadSources();
        loadUsers();
        loadStatus();
    }, []);

    useEffect(() => {
        if (props.singleData.id) props.singleData.contact = { id: props.singleData.contactId || 0, contact_Person_Name: props.singleData.contactName + ' | ' + props.singleData.contactContact };
        reset(props.singleData);
    }, [props.singleData]);


    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            setSources(await response.json());
        }
    }

    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            setUsers(await response.json());
        }
    }

    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact_Person/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }
    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            setStatus(await response.json());
        }
    }

    const saveToDB = async (body: ILead) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        body.contact_ID = body.contact?.id;
        delete body.contact;

        const response = await Fetch(`leads${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ILead) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Lead" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdownInput disabled={props.singleData.id ? true : false} required completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" error={errors.contact?.id?.message} options={contacts} optionLabel="contact_Person_Name" placeholder="Search Contact" />
                <JVDropdown required label="Source" control={control} options={sources} optionLabel="source_Name" optionValue="id" name="source_ID" placeholder="Select Source" error={errors.source_ID?.message} />
                <JVDropdown label="Assign To" control={control} options={users} optionLabel="name" optionValue="id" name="assigned_To" placeholder="Select" error={errors.assigned_To?.message} />
                <JVDropdown disabled required label="Status" control={control} options={status} optionLabel="status_Name" optionValue="id" name="status_ID" placeholder="Select Status" error={errors.status_ID?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}